export const STORAGE_KEYS = {
	session: 'crmQuizSession',
	draft: 'crmQuizDraft',
	resultUrl: 'crmQuizResultUrl',
	resultData: 'crmQuizResultData',
	lead: 'crmQuizLeadData',
};

export const localeTexts = {
	en: {
		badge: 'SMART business',
		title: 'Which CRM fits your business?',
		description: 'Answer 12 questions and get a tailored recommendation between SMART CRM and Microsoft Dynamics 365.',
		progress: 'Question',
		questionLabel: 'Question',
		of: 'of',
		next: 'Next',
		back: 'Back',
		results: 'See results',
		multiHint: 'Select all that apply',
		resultsBadge: 'Results',
		resultsTitle: 'Your recommendation is ready',
		scoreLabel: 'Your match',
		scoreRelevance: 'relevance score',
		recommendation: 'Recommendation',
		recommendedBadge: 'RECOMMENDED',
		sendCta: 'Send to CRM',
		consultCta: 'Book a free consultation',
		restartNew: 'Start a new attempt',
		restart: 'Retake the quiz',
		savedResult: 'Saved result',
		leadTitle: 'Leave your details',
		leadDescr: 'If you want us to review your answers with a consultant, leave your contact data. We will combine it with your quiz answers.',
		noLead: 'No contact details yet. We will send the result to CRM only.',
		continueLink: 'Open saved result',
		loading: 'Saving...',
		error: 'Something went wrong. Try again.',
		recommendations: {
			smart: {
				title: 'SMART CRM',
				icon: '🚀',
				body:
					'Based on your answers, SMART CRM is the optimal choice. Built by SMART business on Microsoft technology, it delivers fast deployment (from 3 weeks), intuitive daily use, and complete coverage of sales, marketing, and service — without enterprise overhead. Fast implementation from 3 weeks',
				features: [
					'Fast implementation from 3 weeks',
					'Ideal for SMB and mid-market',
					'B2B, B2C sales and service',
					'Cloud-based on Microsoft infrastructure',
					'Transparent licensing, no excess costs',
					'Ready connectors: Nova Poshta, Binotel, Viber, Telegram',
				],
			},
			d365: {
				title: 'Microsoft Dynamics 365',
				icon: '🏢',
				body:
					'Based on your answers, Microsoft Dynamics 365 is the strongest fit. It is the enterprise-grade platform for complex processes, deep Microsoft integration, advanced AI, and scalable international operations.',
				features: [
					'Dynamics 365 Sales and Customer Service',
					'Native Microsoft 365 / Teams integration',
					'Power BI for executive analytics',
					'Customer Insights CDP',
					'Microsoft Copilot AI across workflows',
					'Unlimited international scalability',
				],
			},
			tie: {
				title: 'Consult a specialist',
				icon: '⚖️',
				body: 'Your answers are balanced between both systems. We recommend speaking with a SMART business consultant to find the best fit for your specific case.',
				features: [],
			},
		},
	},
	uk: {
		badge: 'SMART business',
		title: 'Який CRM підходить вашому бізнесу?',
		description: 'Дайте відповіді на 12 запитань та отримайте персональну рекомендацію щодо вибору між SMART CRM і Microsoft Dynamics 365.',
		progress: 'Питання',
		questionLabel: 'ПИТАННЯ',
		of: 'з',
		next: 'Далі',
		back: 'Назад',
		results: 'Показати результат',
		multiHint: 'Оберіть всі варіанти, що підходять',
		resultsBadge: 'Результат',
		resultsTitle: 'Рекомендація готова',
		scoreLabel: 'Ваше співпадіння',
		scoreRelevance: 'рівень релевантності',
		recommendation: 'Рекомендація',
		recommendedBadge: 'РЕКОМЕНДОВАНО',
		sendCta: 'Надіслати в CRM',
		consultCta: 'Безкоштовна консультація',
		restartNew: 'Почати нову спробу',
		restart: 'Пройти ще раз',
		savedResult: 'Збережений результат',
		leadTitle: 'Залиште свої дані',
		leadDescr: 'Якщо хочете, щоб ми розібрали ваші відповіді разом із консультантом, залиште контакти. Ми об’єднаємо їх із результатами квізу.',
		noLead: 'Контактних даних ще немає. Ми надішлемо результат лише в CRM.',
		continueLink: 'Відкрити збережений результат',
		loading: 'Зберігаємо...',
		error: 'Щось пішло не так. Спробуйте ще раз.',
		recommendations: {
			smart: {
				title: 'SMART CRM',
				icon: '🚀',
				body:
					'За вашими відповідями SMART CRM є найкращим вибором. Система створена для швидкого запуску, зручної щоденної роботи та повного покриття продажів, маркетингу й сервісу без зайвої складності.',
				features: [
					'Швидке впровадження від 3 тижнів',
					'Підходить SMB та mid-market',
					'Продажі та сервіс B2B/B2C',
					'Хмарна платформа на інфраструктурі Microsoft',
					'Прозоре ліцензування без зайвих витрат',
					'Готові конектори: Нова пошта, Binotel, Viber, Telegram',
				],
			},
			d365: {
				title: 'Microsoft Dynamics 365',
				icon: '🏢',
				body:
					'За вашими відповідями найкраще підходить Microsoft Dynamics 365. Це enterprise-платформа для складних процесів, глибокої інтеграції з Microsoft, AI та масштабування на міжнародні команди.',
				features: [
					'Dynamics 365 Sales та Customer Service',
					'Нативна інтеграція з Microsoft 365 / Teams',
					'Power BI для управлінської аналітики',
					'Customer Insights CDP',
					'Microsoft Copilot AI у всіх workflow',
					'Масштабування без обмежень',
				],
			},
			tie: {
				title: 'Потрібна консультація',
				icon: '⚖️',
				body: 'Ваші відповіді збалансовані між обома системами. Радимо обговорити кейс із консультантом SMART business, щоб обрати точніше.',
				features: [],
			},
		},
	},
	pl: {
		badge: 'SMART business',
		title: 'Który CRM pasuje do Twojej firmy?',
		description: 'Odpowiedz na 12 pytań i otrzymaj dopasowaną rekomendację między SMART CRM a Microsoft Dynamics 365.',
		progress: 'Pytanie',
		questionLabel: 'PYTANIE',
		of: 'z',
		next: 'Dalej',
		back: 'Wstecz',
		results: 'Pokaż wynik',
		multiHint: 'Zaznacz wszystkie pasujące opcje',
		resultsBadge: 'Wynik',
		resultsTitle: 'Twoja rekomendacja jest gotowa',
		scoreLabel: 'Twoje dopasowanie',
		scoreRelevance: 'poziom trafności',
		recommendation: 'Rekomendacja',
		recommendedBadge: 'POLECANE',
		sendCta: 'Wyślij do CRM',
		consultCta: 'Umów bezpłatną konsultację',
		restartNew: 'Rozpocznij nową próbę',
		restart: 'Wypełnij ponownie',
		savedResult: 'Zapisany wynik',
		leadTitle: 'Zostaw swoje dane',
		leadDescr: 'Jeśli chcesz, aby konsultant przejrzał Twoje odpowiedzi, zostaw dane kontaktowe. Połączymy je z wynikami quizu.',
		noLead: 'Brak danych kontaktowych. Wyślemy wynik tylko do CRM.',
		continueLink: 'Otwórz zapisany wynik',
		loading: 'Zapisywanie...',
		error: 'Coś poszło nie tak. Spróbuj ponownie.',
		recommendations: {
			smart: {
				title: 'SMART CRM',
				icon: '🚀',
				body:
					'Na podstawie odpowiedzi SMART CRM jest najlepszym wyborem. System zapewnia szybkie wdrożenie, wygodną pracę na co dzień i pełne wsparcie sprzedaży, marketingu oraz obsługi.',
				features: [
					'Szybkie wdrożenie od 3 tygodni',
					'Idealny dla SMB i mid-market',
					'Sprzedaż i obsługa B2B/B2C',
					'Gotowe konektory: Nova Poshta, Binotel, Viber, Telegram',
					'Przejrzyste licencjonowanie bez zbędnych kosztów',
					'Chmura na infrastrukturze Microsoft',
				],
			},
			d365: {
				title: 'Microsoft Dynamics 365',
				icon: '🏢',
				body:
					'Na podstawie odpowiedzi Microsoft Dynamics 365 jest najmocniejszym wyborem. To platforma klasy enterprise dla złożonych procesów, integracji z Microsoft, AI i skalowania globalnego.',
				features: [
					'Dynamics 365 Sales i Customer Service',
					'Natywna integracja z Microsoft 365 / Teams',
					'Power BI do analityki zarządczej',
					'Customer Insights CDP',
					'Microsoft Copilot AI we wszystkich workflow',
					'Nieograniczone skalowanie międzynarodowe',
				],
			},
			tie: {
				title: 'Skonsultuj z ekspertem',
				icon: '⚖️',
				body: 'Odpowiedzi są zrównoważone między obiema platformami. Rekomendujemy konsultację z ekspertem SMART business, aby dobrać najlepszą opcję.',
				features: [],
			},
		},
	},
	ge: {
		badge: 'SMART business',
		title: 'რომელი CRM შეეფერება თქვენს ბიზნესს?',
		description: 'უპასუხეთ 12 კითხვას და მიიღეთ მორგებული რეკომენდაცია SMART CRM-სა და Microsoft Dynamics 365-ს შორის.',
		progress: 'კითხვა',
		questionLabel: 'კითხვა',
		of: 'დან',
		next: 'შემდეგი',
		back: 'უკან',
		results: 'შედეგის ნახვა',
		multiHint: 'მონიშნეთ ყველა შესაბამისი ვარიანტი',
		resultsBadge: 'შედეგი',
		resultsTitle: 'თქვენი რეკომენდაცია მზად არის',
		scoreLabel: 'თქვენი შესაბამისობა',
		scoreRelevance: 'რელევანტურობის დონე',
		recommendation: 'რეკომენდაცია',
		recommendedBadge: 'რეკომენდებულია',
		sendCta: 'CRM-ში გაგზავნა',
		consultCta: 'უფასო კონსულტაციის დაჯავშნა',
		restartNew: 'ახალი ცდის დაწყება',
		restart: 'კვლავ შევსება',
		savedResult: 'შენახული შედეგი',
		leadTitle: 'დატოვეთ თქვენი მონაცემები',
		leadDescr: 'თუ გსურთ, რომ კონსულტანტმა თქვენი პასუხები განიხილოს, დატოვეთ საკონტაქტო მონაცემები. ჩვენ მათ შევაერთებთ quiz-ის შედეგებთან.',
		noLead: 'საკონტაქტო მონაცემები ჯერ არ არის. შედეგს მხოლოდ CRM-ში გავაგზავნით.',
		continueLink: 'შენახული შედეგის გახსნა',
		loading: 'შენახვა...',
		error: 'რაღაც არ გამოვიდა. სცადეთ თავიდან.',
		recommendations: {
			smart: {
				title: 'SMART CRM',
				icon: '🚀',
				body:
					'თქვენი პასუხების მიხედვით SMART CRM არის საუკეთესო არჩევანი. სისტემა შექმნილია სწრაფი დანერგვისთვის, მარტივი ყოველდღიური მუშაობისთვის და გაყიდვების, მარკეტინგისა და სერვისის სრული დაფარვისთვის.',
				features: [
					'დანერგვა 3 კვირიდან',
					'SMB და mid-market-ისთვის',
					'B2B/B2C გაყიდვები და სერვისი',
					'მზად კონექტორები: Nova Poshta, Binotel, Viber, Telegram',
					'გამჭვირვალე ლიცენზირება ზედმეტი ხარჯების გარეშე',
					'Microsoft-ის ინფრასტრუქტურაზე დაფუძნებული cloud',
				],
			},
			d365: {
				title: 'Microsoft Dynamics 365',
				icon: '🏢',
				body:
					'თქვენი პასუხების მიხედვით Microsoft Dynamics 365 არის ყველაზე ძლიერი არჩევანი. ეს არის enterprise პლატფორმა რთული პროცესებისთვის, Microsoft ეკოსისტემასთან ინტეგრაციისა და AI-სთვის.',
				features: [
					'Dynamics 365 Sales და Customer Service',
					'Microsoft 365 / Teams-ის ნატიური ინტეგრაცია',
					'Power BI მენეჯერული ანალიტიკისთვის',
					'Customer Insights CDP',
					'Microsoft Copilot AI ყველა workflow-ში',
					'გლობალური მასშტაბირება შეზღუდვის გარეშე',
				],
			},
			tie: {
				title: 'სპეციალისტის კონსულტაცია',
				icon: '⚖️',
				body: 'თქვენი პასუხები ორივე სისტემას შორის დაბალანსებულია. რეკომენდებულია SMART business-ის კონსულტანტთან საუბარი.',
				features: [],
			},
		},
	},
	az: {
		badge: 'SMART business',
		title: 'Hansı CRM sizin biznesinizə uyğundur?',
		description: '12 suala cavab verin və SMART CRM ilə Microsoft Dynamics 365 arasında uyğun tövsiyə alın.',
		progress: 'Sual',
		questionLabel: 'SUAL',
		of: 'dən',
		next: 'Növbəti',
		back: 'Geri',
		results: 'Nəticəni göstər',
		multiHint: 'Uyğun olan bütün variantları seçin',
		resultsBadge: 'Nəticə',
		resultsTitle: 'Sizin tövsiyəniz hazırdır',
		scoreLabel: 'Uyğunluq',
		scoreRelevance: 'uyğunluq səviyyəsi',
		recommendation: 'Tövsiyə',
		recommendedBadge: 'TÖVSİYƏ OLUNUR',
		sendCta: 'CRM-ə göndər',
		consultCta: 'Pulsuz məsləhət sifariş et',
		restartNew: 'Yeni cəhdə başla',
		restart: 'Yenidən doldur',
		savedResult: 'Saxlanmış nəticə',
		leadTitle: 'Məlumatlarınızı buraxın',
		leadDescr: 'Əgər konsultantın cavablarınızı yoxlamasını istəyirsinizsə, əlaqə məlumatlarını buraxın. Onları quiz nəticələri ilə birləşdirəcəyik.',
		noLead: 'Hələ əlaqə məlumatı yoxdur. Nəticə yalnız CRM-ə göndəriləcək.',
		continueLink: 'Saxlanmış nəticəni aç',
		loading: 'Saxlanılır...',
		error: 'Nəsə alınmadı. Yenidən yoxlayın.',
		recommendations: {
			smart: {
				title: 'SMART CRM',
				icon: '🚀',
				body: 'Cavablarınıza əsasən SMART CRM ən uyğun seçimdir. Sistem sürətli tətbiq, rahat gündəlik iş və satış, marketinq, servis üçün tam əhatə təmin edir.',
				features: [
					'3 həftədən sürətli tətbiq',
					'SMB və mid-market üçün uyğundur',
					'B2B/B2C satış və servis',
					'Hazır konektorlar: Nova Poshta, Binotel, Viber, Telegram',
					'Şəffaf lisenziya, əlavə xərclərsiz',
					'Microsoft infrastrukturunda cloud',
				],
			},
			d365: {
				title: 'Microsoft Dynamics 365',
				icon: '🏢',
				body: 'Cavablarınıza əsasən Microsoft Dynamics 365 ən güclü seçimdir. Bu, mürəkkəb proseslər, Microsoft inteqrasiyası və AI üçün enterprise platformadır.',
				features: [
					'Dynamics 365 Sales və Customer Service',
					'Microsoft 365 / Teams ilə nativ inteqrasiya',
					'Power BI analitika üçün',
					'Customer Insights CDP',
					'Microsoft Copilot AI bütün workflow-larda',
					'Qlobal miqyaslanma məhdudiyyətsiz',
				],
			},
			tie: {
				title: 'Mütəxəssis konsultasiyası',
				icon: '⚖️',
				body: 'Cavablarınız iki sistem arasında balanslıdır. Ən uyğun variant üçün SMART business konsultantı ilə danışmağı tövsiyə edirik.',
				features: [],
			},
		},
	},
	es: {
		badge: 'SMART business',
		title: '¿Qué CRM encaja con tu negocio?',
		description: 'Responde 12 preguntas y recibe una recomendación personalizada entre SMART CRM y Microsoft Dynamics 365.',
		progress: 'Pregunta',
		questionLabel: 'PREGUNTA',
		of: 'de',
		next: 'Siguiente',
		back: 'Atrás',
		results: 'Ver resultado',
		multiHint: 'Selecciona todas las opciones que apliquen',
		resultsBadge: 'Resultado',
		resultsTitle: 'Tu recomendación está lista',
		scoreLabel: 'Tu coincidencia',
		scoreRelevance: 'nivel de relevancia',
		recommendation: 'Recomendación',
		recommendedBadge: 'RECOMENDADO',
		sendCta: 'Enviar a CRM',
		consultCta: 'Reservar consulta gratuita',
		restartNew: 'Empezar nuevo intento',
		restart: 'Repetir el cuestionario',
		savedResult: 'Resultado guardado',
		leadTitle: 'Deja tus datos',
		leadDescr: 'Si quieres que revisemos tus respuestas con un consultor, deja tus datos de contacto. Los combinaremos con el resultado del quiz.',
		noLead: 'Todavía no hay datos de contacto. Enviaremos el resultado solo al CRM.',
		continueLink: 'Abrir resultado guardado',
		loading: 'Guardando...',
		error: 'Algo salió mal. Inténtalo de nuevo.',
		recommendations: {
			smart: {
				title: 'SMART CRM',
				icon: '🚀',
				body:
					'Según tus respuestas, SMART CRM es la mejor opción. Está diseñado para una implementación rápida, uso diario intuitivo y cobertura completa de ventas, marketing y servicio sin complejidad empresarial.',
				features: [
					'Implementación rápida desde 3 semanas',
					'Ideal para SMB y mid-market',
					'Ventas y servicio B2B/B2C',
					'Conectores listos: Nova Poshta, Binotel, Viber, Telegram',
					'Licenciamiento transparente, sin costos extra',
					'Basado en la nube de Microsoft',
				],
			},
			d365: {
				title: 'Microsoft Dynamics 365',
				icon: '🏢',
				body:
					'Según tus respuestas, Microsoft Dynamics 365 es la mejor opción. Es una plataforma enterprise para procesos complejos, integración con Microsoft, IA avanzada y escalabilidad global.',
				features: [
					'Dynamics 365 Sales y Customer Service',
					'Integración nativa con Microsoft 365 / Teams',
					'Power BI para analítica ejecutiva',
					'Customer Insights CDP',
					'Microsoft Copilot AI en todos los flujos',
					'Escalabilidad internacional ilimitada',
				],
			},
			tie: {
				title: 'Consulta con un especialista',
				icon: '⚖️',
				body: 'Tus respuestas están equilibradas entre ambos sistemas. Recomendamos hablar con un consultor de SMART business para elegir la mejor opción.',
				features: [],
			},
		},
	},
};

export const questionBank = [
	{
		id: 'q1',
		multiple: false,
		text: {
			en: 'What is your business model?',
			uk: 'Яка у вас бізнес-модель?',
			pl: 'Jaki jest Twój model biznesowy?',
			ge: 'რა არის თქვენი ბიზნეს-მოდელი?',
			az: 'Biznes modeliniz nədir?',
			es: '¿Cuál es tu modelo de negocio?',
		},
		options: [
			{
				text: {
					en: 'B2C - retail, e-commerce, end consumers',
					uk: 'B2C - ритейл, e-commerce, кінцеві споживачі',
					pl: 'B2C - retail, e-commerce, klienci końcowi',
					ge: 'B2C - რითეილ, e-commerce, საბოლოო მომხმარებლები',
					az: 'B2C - retail, e-commerce, son müştərilər',
					es: 'B2C - retail, e-commerce, consumidores finales',
				},
				smart: 3,
				d365: 1,
			},
			{
				text: {
					en: 'B2B - corporate clients, deals, contracts',
					uk: 'B2B - корпоративні клієнти, угоди, контракти',
					pl: 'B2B - klienci korporacyjni, transakcje, umowy',
					ge: 'B2B - კორპორატიული კლიენტები, გარიგებები, კონტრაქტები',
					az: 'B2B - korporativ müştərilər, sövdələşmələr, müqavilələr',
					es: 'B2B - clientes corporativos, acuerdos, contratos',
				},
				smart: 3,
				d365: 3,
			},
			{
				text: {
					en: 'Hybrid - both B2B and B2C simultaneously',
					uk: 'Гібридна - B2B і B2C одночасно',
					pl: 'Hybrydowy - B2B i B2C jednocześnie',
					ge: 'ჰიბრიდული - ერთდროულად B2B და B2C',
					az: 'Hibrid - həm B2B, həm də B2C',
					es: 'Híbrido - B2B y B2C simultáneamente',
				},
				smart: 3,
				d365: 2,
			},
			{
				text: {
					en: 'B2G - government, tenders, public procurement',
					uk: 'B2G - держава, тендери, публічні закупівлі',
					pl: 'B2G - administracja, przetargi, zamówienia publiczne',
					ge: 'B2G - სახელმწიფო, ტენდერები, საჯარო შესყიდვები',
					az: 'B2G - dövlət, tenderlər, ictimai satınalmalar',
					es: 'B2G - gobierno, licitaciones, contratación pública',
				},
				smart: 2,
				d365: 2,
			},
		],
	},
	{
		id: 'q2',
		multiple: false,
		text: {
			en: 'How many employees does your company have?',
			uk: 'Скільки співробітників у вашій компанії?',
			pl: 'Ilu pracowników ma Twoja firma?',
			ge: 'რამდენი თანამშრომელი ჰყავს თქვენს კომპანიას?',
			az: 'Şirkətinizdə neçə işçi var?',
			es: '¿Cuántos empleados tiene tu empresa?',
		},
		options: [
			{
				text: {
					en: 'Up to 50',
					uk: 'До 50',
					pl: 'Do 50',
					ge: '50-მდე',
					az: '50-yə qədər',
					es: 'Hasta 50',
				},
				smart: 3,
				d365: 3,
			},
			{
				text: {
					en: '50-200',
					uk: '50-200',
					pl: '50-200',
					ge: '50-200',
					az: '50-200',
					es: '50-200',
				},
				smart: 2,
				d365: 2,
			},
			{
				text: {
					en: '200-1,000',
					uk: '200-1 000',
					pl: '200-1 000',
					ge: '200-1 000',
					az: '200-1 000',
					es: '200-1.000',
				},
				smart: 3,
				d365: 1,
			},
			{
				text: {
					en: '1,000+',
					uk: '1 000+',
					pl: '1 000+',
					ge: '1 000+',
					az: '1 000+',
					es: '1.000+',
				},
				smart: 3,
				d365: 0,
			},
		],
	},
	{
		id: 'q3',
		multiple: false,
		text: {
			en: 'What is your average sales cycle length?',
			uk: 'Яка у вас середня довжина циклу продажів?',
			pl: 'Jaka jest średnia długość cyklu sprzedaży?',
			ge: 'რა არის თქვენი საშუალო გაყიდვების ციკლის ხანგრძლივობა?',
			az: 'Orta satış dövrünüz nə qədərdir?',
			es: '¿Cuál es la duración media de tu ciclo de ventas?',
		},
		options: [
			{
				text: {
					en: 'Hours to days - fast transactional sales',
					uk: 'Години або дні - швидкі транзакційні продажі',
					pl: 'Godziny do dni - szybka sprzedaż transakcyjna',
					ge: 'საათებიდან დღეებამდე - სწრაფი ტრანზაქციული გაყიდვები',
					az: 'Saatlardan günlərə - sürətli tranzaksion satış',
					es: 'Horas o días - ventas transaccionales rápidas',
				},
				smart: 3,
				d365: 0,
			},
			{
				text: {
					en: '1-4 weeks',
					uk: '1-4 тижні',
					pl: '1-4 tygodnie',
					ge: '1-4 კვირა',
					az: '1-4 həftə',
					es: '1-4 semanas',
				},
				smart: 2,
				d365: 2,
			},
			{
				text: {
					en: '1-3 months',
					uk: '1-3 місяці',
					pl: '1-3 miesiące',
					ge: '1-3 თვე',
					az: '1-3 ay',
					es: '1-3 meses',
				},
				smart: 3,
				d365: 3,
			},
			{
				text: {
					en: '3+ months - complex enterprise deals',
					uk: '3+ місяці - складні enterprise-угоди',
					pl: '3+ miesiące - złożone transakcje enterprise',
					ge: '3+ თვე - რთული enterprise გარიგებები',
					az: '3+ ay - mürəkkəb enterprise sövdələşmələr',
					es: '3+ meses - acuerdos empresariales complejos',
				},
				smart: 2,
				d365: 3,
			},
		],
	},
	{
		id: 'q4',
		multiple: false,
		text: {
			en: 'How important is sales analytics and forecasting for you?',
			uk: 'Наскільки важливі для вас аналітика продажів і прогнозування?',
			pl: 'Jak ważna jest dla Ciebie analityka sprzedaży i prognozowanie?',
			ge: 'რამდენად მნიშვნელოვანია თქვენთვის გაყიდვების ანალიტიკა და პროგნოზირება?',
			az: 'Satış analitikası və proqnozlaşdırma sizin üçün nə qədər vacibdir?',
			es: '¿Qué tan importantes son para ti la analítica y la previsión de ventas?',
		},
		options: [
			{
				text: {
					en: 'Not critical - basic reports are enough',
					uk: 'Не критично - достатньо базових звітів',
					pl: 'Niekrytyczne - wystarczą podstawowe raporty',
					ge: 'არ არის კრიტიკული - საკმარისია საბაზისო ანგარიშები',
					az: 'Kritik deyil - əsas hesabatlar kifayətdir',
					es: 'No es crítico - bastan informes básicos',
				},
				smart: 3,
				d365: 2,
			},
			{
				text: {
					en: 'Important - dashboards and KPI tracking needed',
					uk: 'Важливо - потрібні дашборди та KPI',
					pl: 'Ważne - potrzebne dashboardy i KPI',
					ge: 'მნიშვნელოვანია - საჭიროა dashboard-ები და KPI კონტროლი',
					az: 'Vacibdir - dashboard və KPI izləmə lazımdır',
					es: 'Importante - se necesitan dashboards y seguimiento de KPI',
				},
				smart: 2,
				d365: 3,
			},
			{
				text: {
					en: 'Very important - need pipeline forecasting and AI insights',
					uk: 'Дуже важливо - потрібен прогноз pipeline і AI-інсайти',
					pl: 'Bardzo ważne - potrzebne prognozowanie lejka i insighty AI',
					ge: 'ძალიან მნიშვნელოვანია - საჭიროა pipeline პროგნოზი და AI ანალიზი',
					az: 'Çox vacibdir - pipeline proqnozu və AI insight-lar lazımdır',
					es: 'Muy importante - se necesita previsión del pipeline e insights de IA',
				},
				smart: 1,
				d365: 3,
			},
			{
				text: {
					en: 'Critical - advanced BI, Power BI, predictive analytics',
					uk: 'Критично - advanced BI, Power BI, предиктивна аналітика',
					pl: 'Krytyczne - zaawansowane BI, Power BI, analityka predykcyjna',
					ge: 'კრიტიკულია - advanced BI, Power BI, პროგნოზული ანალიტიკა',
					az: 'Kritikdir - advanced BI, Power BI, proqnoz analitikası',
					es: 'Crítico - BI avanzado, Power BI, analítica predictiva',
				},
				smart: 0,
				d365: 3,
			},
		],
	},
	{
		id: 'q5',
		multiple: true,
		text: {
			en: 'What types of integrations do you need?',
			uk: 'Які типи інтеграцій вам потрібні?',
			pl: 'Jakich integracji potrzebujesz?',
			ge: 'რა ტიპის ინტეგრაციები გჭირდებათ?',
			az: 'Sizə hansı inteqrasiya növləri lazımdır?',
			es: '¿Qué tipos de integraciones necesitas?',
		},
		options: [
			{
				text: {
					en: 'Telephony, website forms, email',
					uk: 'Телефонія, вебформи, email',
					pl: 'Telefonia, formularze, e-mail',
					ge: 'ტელეფონია, ვებსაიტის ფორმები, email',
					az: 'Telefoniya, sayt formaları, email',
					es: 'Telefonía, formularios web, correo',
				},
				smart: 2,
				d365: 3,
			},
			{
				text: {
					en: 'Messengers (Viber, Telegram), SMS, marketplaces',
					uk: 'Месенджери (Viber, Telegram), SMS, маркетплейси',
					pl: 'Komunikatory (Viber, Telegram), SMS, marketplace',
					ge: 'მესენჯერები (Viber, Telegram), SMS, მარკეტფლეისები',
					az: 'Messenger-lər (Viber, Telegram), SMS, marketplace-lər',
					es: 'Mensajería (Viber, Telegram), SMS, marketplaces',
				},
				smart: 3,
				d365: 3,
			},
			{
				text: {
					en: 'Accounting / ERP / logistics systems',
					uk: 'Бухгалтерія / ERP / логістичні системи',
					pl: 'Księgowość / ERP / logistyka',
					ge: 'ბუღალტერია / ERP / ლოჯისტიკა',
					az: 'Mühasibat / ERP / logistika sistemləri',
					es: 'Contabilidad / ERP / logística',
				},
				smart: 2,
				d365: 3,
			},
			{
				text: {
					en: 'Microsoft 365, Teams, Azure, Power Platform',
					uk: 'Microsoft 365, Teams, Azure, Power Platform',
					pl: 'Microsoft 365, Teams, Azure, Power Platform',
					ge: 'Microsoft 365, Teams, Azure, Power Platform',
					az: 'Microsoft 365, Teams, Azure, Power Platform',
					es: 'Microsoft 365, Teams, Azure, Power Platform',
				},
				smart: 2,
				d365: 3,
			},
		],
	},
	{
		id: 'q6',
		multiple: false,
		text: {
			en: 'What is your estimated CRM budget?',
			uk: 'Який у вас орієнтовний бюджет на CRM?',
			pl: 'Jaki jest Twój szacowany budżet na CRM?',
			ge: 'რა არის თქვენი CRM-ის სავარაუდო ბიუჯეტი?',
			az: 'CRM üçün təxmini büdcəniz nə qədərdir?',
			es: '¿Cuál es tu presupuesto estimado para CRM?',
		},
		options: [
			{
				text: {
					en: 'Limited - looking for a cost-effective solution',
					uk: 'Обмежений — важлива оптимальна вартість',
					pl: 'Ograniczony - szukamy ekonomicznego rozwiązania',
					ge: 'შეზღუდული - ვეძებთ ხარჯთეფექტურ გადაწყვეტას',
					az: 'Məhduddur - sərfəli həll axtarırıq',
					es: 'Limitado - buscamos una solución rentable',
				},
				smart: 3,
				d365: 0,
			},
			{
				text: {
					en: 'Moderate - ready to invest for the right fit',
					uk: 'Помірний - готові інвестувати в правильне рішення',
					pl: 'Umiarkowany - jesteśmy gotowi zainwestować w odpowiednie rozwiązanie',
					ge: 'საშუალო - მზად ვართ ჩავდოთ სწორი გადაწყვეტისთვის',
					az: 'Orta - uyğun həll üçün investisiya etməyə hazırıq',
					es: 'Moderado - listos para invertir en la opción correcta',
				},
				smart: 2,
				d365: 2,
			},
			{
				text: {
					en: 'Flexible - enterprise budget, ROI-driven decision',
					uk: 'Гнучкий - enterprise-бюджет, рішення на основі ROI',
					pl: 'Elastyczny - budżet enterprise, decyzja oparta na ROI',
					ge: 'მოქნილი - enterprise ბიუჯეტი, ROI-ზე დაფუძნებული გადაწყვეტილება',
					az: 'Çevik - enterprise büdcə, ROI əsaslı qərar',
					es: 'Flexible - presupuesto enterprise, decisión basada en ROI',
				},
				smart: 0,
				d365: 3,
			},
			{
				text: {
					en: 'Not defined yet - need a consultation first',
					uk: 'Ще не визначений - спочатку потрібна консультація',
					pl: 'Jeszcze nieokreślony - najpierw potrzebna konsultacja',
					ge: 'ჯერ არ არის განსაზღვრული - პირველად კონსულტაციაა საჭირო',
					az: 'Hələ müəyyən edilməyib - əvvəlcə məsləhət lazımdır',
					es: 'Aún no definido - primero necesito una consulta',
				},
				smart: 1,
				d365: 1,
			},
		],
	},
	{
		id: 'q7',
		multiple: false,
		text: {
			en: 'How important is AI assistance for your sales team?',
			uk: 'Наскільки важлива AI-підтримка для вашої команди продажів?',
			pl: 'Jak ważne jest wsparcie AI dla Twojego zespołu sprzedaży?',
			ge: 'რამდენად მნიშვნელოვანია AI მხარდაჭერა თქვენი გაყიდვების გუნდისთვის?',
			az: 'Satış komandanız üçün AI dəstəyi nə qədər vacibdir?',
			es: '¿Qué tan importante es la ayuda de IA para tu equipo de ventas?',
		},
		options: [
			{
				text: {
					en: 'Not important - we rely on experience and intuition',
					uk: 'Не важливо - покладаємось на досвід та інтуїцію',
					pl: 'Nieważne - polegamy na doświadczeniu i intuicji',
					ge: 'არ არის მნიშვნელოვანი - ვეყრდნობით გამოცდილებას და ინტუიციას',
					az: 'Vacib deyil - təcrübə və intuisiya ilə işləyirik',
					es: 'No es importante - confiamos en la experiencia y la intuición',
				},
				smart: 3,
				d365: 0,
			},
			{
				text: {
					en: 'Nice to have - basic suggestions would help',
					uk: 'Було б корисно - базові підказки допоможуть',
					pl: 'Miłe, ale niekonieczne - podstawowe podpowiedzi pomogłyby',
					ge: 'კარგი იქნებოდა - საბაზისო რეკომენდაციები დაგვეხმარება',
					az: 'Faydalı olar - əsas təkliflər kömək edər',
					es: 'Sería útil - sugerencias básicas ayudarían',
				},
				smart: 2,
				d365: 1,
			},
			{
				text: {
					en: 'Important - email summaries, deal insights, next-step recommendations',
					uk: 'Важливо - email-резюме, інсайти по угодах, рекомендації наступних кроків',
					pl: 'Ważne - podsumowania e-mail, insighty o dealach, rekomendacje kolejnych kroków',
					ge: 'მნიშვნელოვანია - email შეჯამებები, გარიგების ინსაიტები, შემდეგი ნაბიჯების რეკომენდაციები',
					az: 'Vacibdir - email xülasələri, sövdələşmə insaytları, növbəti addım tövsiyələri',
					es: 'Importante - resúmenes por email, insights de acuerdos, recomendaciones del siguiente paso',
				},
				smart: 0,
				d365: 3,
			},
			{
				text: {
					en: 'Critical - AI deeply embedded in every sales workflow',
					uk: 'Критично - AI глибоко вбудований у кожен sales workflow',
					pl: 'Krytyczne - AI głęboko wbudowane w każdy workflow sprzedaży',
					ge: 'კრიტიკულია - AI ღრმად ინტეგრირებულია ყველა sales workflow-ში',
					az: 'Kritikdir - AI hər satış workflow-una dərin inteqrasiya olunub',
					es: 'Crítico - la IA está profundamente integrada en cada flujo de ventas',
				},
				smart: 0,
				d365: 3,
			},
		],
	},
	{
		id: 'q8',
		multiple: false,
		text: {
			en: 'Do you need to unify customer data from multiple sources into a single profile?',
			uk: 'Чи потрібно об’єднати дані клієнтів із кількох джерел в єдиний профіль?',
			pl: 'Czy musisz scalić dane klientów z wielu źródeł w jeden profil?',
			ge: 'გჭირდებათ თუ არა მრავალ წყაროდან მიღებული მონაცემების გაერთიანება ერთ პროფილში?',
			az: 'Müştəri məlumatlarını bir neçə mənbədən vahid profile birləşdirmək lazımdır?',
			es: '¿Necesitas unificar datos de clientes de múltiples fuentes en un solo perfil?',
		},
		options: [
			{
				text: {
					en: 'No - our customer data lives in one system',
					uk: 'Ні - дані клієнтів зберігаються в одній системі',
					pl: 'Nie - dane klientów są w jednym systemie',
					ge: 'არა - ჩვენი მონაცემები ერთ სისტემაშია',
					az: 'Xeyr - müştəri məlumatlarımız bir sistemdədir',
					es: 'No - nuestros datos viven en un solo sistema',
				},
				smart: 3,
				d365: 0,
			},
			{
				text: {
					en: 'Somewhat - we have 2-3 sources we would like to connect',
					uk: 'Частково - маємо 2-3 джерела, які хочемо з’єднати',
					pl: 'Częściowo - mamy 2-3 źródła, które chcemy połączyć',
					ge: 'ნაწილობრივ - გვაქვს 2-3 წყარო, რომელთა დაკავშირება გვინდა',
					az: 'Qismən - birləşdirmək istədiyimiz 2-3 mənbə var',
					es: 'Algo - tenemos 2-3 fuentes que queremos conectar',
				},
				smart: 2,
				d365: 2,
			},
			{
				text: {
					en: 'Yes - we need a unified profile from CRM, web, support, POS',
					uk: 'Так - потрібен єдиний профіль із CRM, сайту, підтримки, POS',
					pl: 'Tak - potrzebujemy jednego profilu z CRM, web, supportu i POS',
					ge: 'დიახ - გვჭირდება ერთიანი პროფილი CRM, ვებ, support, POS-იდან',
					az: 'Bəli - CRM, web, dəstək, POS-dan vahid profil lazımdır',
					es: 'Sí - necesitamos un perfil unificado desde CRM, web, soporte y POS',
				},
				smart: 0,
				d365: 3,
			},
			{
				text: {
					en: 'Yes - full CDP with real-time data from all touchpoints',
					uk: 'Так - повноцінний CDP з реальними даними з усіх touchpoints',
					pl: 'Tak - pełny CDP z danymi w czasie rzeczywistym ze wszystkich punktów styku',
					ge: 'დიახ - სრული CDP რეალურ დროში ყველა touchpoint-იდან',
					az: 'Bəli - bütün touchpoint-lərdən real-time məlumatlı CDP',
					es: 'Sí - CDP completo con datos en tiempo real de todos los puntos de contacto',
				},
				smart: 0,
				d365: 3,
			},
		],
	},
	{
		id: 'q9',
		multiple: false,
		text: {
			en: 'How complex are your customer journeys?',
			uk: 'Наскільки складні ваші customer journey?',
			pl: 'Jak złożone są Twoje customer journey?',
			ge: 'რამდენად რთულია თქვენი customer journey-ები?',
			az: 'Müştəri journey-ləriniz nə qədər mürəkkəbdir?',
			es: '¿Qué tan complejos son tus customer journeys?',
		},
		options: [
			{
				text: {
					en: "We don't run marketing campaigns yet",
					uk: 'Ми ще не запускаємо маркетингові кампанії',
					pl: 'Jeszcze nie prowadzimy kampanii marketingowych',
					ge: 'ჯერ არ ვატარებთ marketing campaign-ებს',
					az: 'Hələ marketinq kampaniyaları aparmırıq',
					es: 'Todavía no ejecutamos campañas de marketing',
				},
				smart: 1,
				d365: 1,
			},
			{
				text: {
					en: 'Basic campaigns - email, SMS, Viber newsletters',
					uk: 'Базові кампанії - email, SMS, Viber-розсилки',
					pl: 'Podstawowe kampanie - e-mail, SMS, newslettery Viber',
					ge: 'საბაზისო კამპანიები - email, SMS, Viber',
					az: 'Əsas kampaniyalar - email, SMS, Viber xəbər bülletenləri',
					es: 'Campañas básicas - email, SMS, boletines de Viber',
				},
				smart: 3,
				d365: 0,
			},
			{
				text: {
					en: 'Automated flows triggered by customer actions',
					uk: 'Автоматичні сценарії, що запускаються діями клієнтів',
					pl: 'Automatyczne flow uruchamiane działaniami klientów',
					ge: 'ავტომატიზებული flow-ები, რომლებიც მომხმარებლის ქმედებებზე ირთვება',
					az: 'Müştəri hərəkətləri ilə başlayan avtomatlaşdırılmış axınlar',
					es: 'Flujos automatizados activados por acciones del cliente',
				},
				smart: 1,
				d365: 3,
			},
			{
				text: {
					en: 'Multi-step omnichannel journeys with branching logic and real-time triggers',
					uk: 'Багатокрокові omnichannel-сценарії з розгалуженням і тригерами в реальному часі',
					pl: 'Wieloetapowe journey omnichannel z logiką rozgałęzień i triggerami w czasie rzeczywistym',
					ge: 'მრავალსაფეხურიანი omnichannel journey-ები განშტოებული ლოგიკით და real-time trigger-ებით',
					az: 'Şaxələnən məntiq və real-time trigger-lərlə çoxmərhələli omnichannel journey-lər',
					es: 'Customer journeys omnicanal de varios pasos con lógica ramificada y triggers en tiempo real',
				},
				smart: 0,
				d365: 3,
			},
		],
	},
	{
		id: 'q10',
		multiple: false,
		text: {
			en: 'How large is the audience you need to engage?',
			uk: 'Яка у вас аудиторія, з якою потрібно працювати?',
			pl: 'Jak duża jest grupa odbiorców, z którą musisz pracować?',
			ge: 'რამდენად დიდია აუდიტორია, რომელთანაც მუშაობა გჭირდებათ?',
			az: 'İşləməli olduğunuz auditoriya nə qədər böyükdür?',
			es: '¿Qué tan grande es la audiencia con la que necesitas interactuar?',
		},
		options: [
			{
				text: {
					en: 'Up to 10,000 contacts',
					uk: 'До 10 000 контактів',
					pl: 'Do 10 000 kontaktów',
					ge: '10 000-მდე კონტაქტი',
					az: '10 000-ə qədər kontakt',
					es: 'Hasta 10.000 contactos',
				},
				smart: 3,
				d365: 1,
			},
			{
				text: {
					en: '10,000-100,000 contacts',
					uk: '10 000-100 000 контактів',
					pl: '10 000-100 000 kontaktów',
					ge: '10 000-100 000 კონტაქტი',
					az: '10 000-100 000 kontakt',
					es: '10.000-100.000 contactos',
				},
				smart: 2,
				d365: 2,
			},
			{
				text: {
					en: '100,000-1,000,000 contacts',
					uk: '100 000-1 000 000 контактів',
					pl: '100 000-1 000 000 kontaktów',
					ge: '100 000-1 000 000 კონტაქტი',
					az: '100 000-1 000 000 kontakt',
					es: '100.000-1.000.000 contactos',
				},
				smart: 1,
				d365: 3,
			},
			{
				text: {
					en: '1,000,000+ contacts',
					uk: '1 000 000+ контактів',
					pl: '1 000 000+ kontaktów',
					ge: '1 000 000+ კონტაქტი',
					az: '1 000 000+ kontakt',
					es: '1.000.000+ contactos',
				},
				smart: 0,
				d365: 3,
			},
		],
	},
	{
		id: 'q11',
		multiple: false,
		text: {
			en: 'Do you need AI to automatically score and prioritize leads and deals by likelihood to close?',
			uk: 'Чи потрібно, щоб AI автоматично оцінював і пріоритизував ліди та угоди за ймовірністю закриття?',
			pl: 'Czy potrzebujesz AI, aby automatycznie oceniało i priorytetyzowało leady i deale według prawdopodobieństwa zamknięcia?',
			ge: 'გჭირდებათ AI, რომელიც ავტომატურად შეაფასებს და დააპრიორიტეტებს ლიდებს და გარიგებებს დახურვის ალბათობით?',
			az: 'AI-nin lead və sövdələşmələri bağlanma ehtimalına görə avtomatik qiymətləndirməsi və prioritetləşdirməsi lazımdır?',
			es: '¿Necesitas IA para puntuar y priorizar automáticamente leads y oportunidades según la probabilidad de cierre?',
		},
		options: [
			{
				text: {
					en: 'No - we prioritize manually based on experience',
					uk: 'Ні - пріоритизуємо вручну на основі досвіду',
					pl: 'Nie - priorytetyzujemy ręcznie na podstawie doświadczenia',
					ge: 'არა - პრიორიტეტებს გამოცდილებით ვანიჭებთ',
					az: 'Xeyr - təcrübəyə əsasən əl ilə prioritetləşdiririk',
					es: 'No - priorizamos manualmente según la experiencia',
				},
				smart: 2,
				d365: 2,
			},
			{
				text: {
					en: 'Would be useful, but not a priority right now',
					uk: 'Було б корисно, але це не пріоритет',
					pl: 'Byłoby przydatne, ale nie jest to teraz priorytet',
					ge: 'კარგი იქნებოდა, მაგრამ ახლა პრიორიტეტი არ არის',
					az: 'Faydalı olar, amma hazırda prioritet deyil',
					es: 'Sería útil, pero no es prioridad ahora',
				},
				smart: 2,
				d365: 1,
			},
			{
				text: {
					en: 'Yes - we have too many leads to prioritize manually',
					uk: 'Так - у нас занадто багато лідів для ручного пріоритезування',
					pl: 'Tak - mamy zbyt wiele leadów, aby priorytetyzować ręcznie',
					ge: 'დიახ - ძალიან ბევრი ლიდია ხელით დასაპრიორიტეტებლად',
					az: 'Bəli - əl ilə prioritetləşdirmək üçün çoxlu lead var',
					es: 'Sí - tenemos demasiados leads para priorizarlos manualmente',
				},
				smart: 3,
				d365: 1,
			},
			{
				text: {
					en: 'Yes - critical, we need AI scoring across the full pipeline',
					uk: 'Так - критично, потрібен AI scoring по всьому pipeline',
					pl: 'Tak - krytyczne, potrzebujemy scoringu AI w całym pipeline',
					ge: 'დიახ - კრიტიკულია, გვჭირდება AI scoring მთელი pipeline-ისთვის',
					az: 'Bəli - kritikdir, bütün pipeline üzrə AI scoring lazımdır',
					es: 'Sí - crítico, necesitamos scoring de IA en todo el pipeline',
				},
				smart: 0,
				d365: 3,
			},
		],
	},
	{
		id: 'q12',
		multiple: false,
		text: {
			en: 'Do your sales reps need AI-guided daily action queues - who to contact next and how?',
			uk: 'Чи потрібні вашим sales-менеджерам AI-підказки на щодень - кого контактувати далі і як?',
			pl: 'Czy Twoi handlowcy potrzebują AI, która prowadzi codzienną listę działań - kogo kontaktować dalej i jak?',
			ge: 'საჭიროა თუ არა თქვენს sales წარმომადგენლებს AI-ით მართული ყოველდღიური action queue - ვის დაუკავშირდნენ შემდეგ და როგორ?',
			az: 'Satış nümayəndələrinizə AI ilə idarə olunan gündəlik action queue lazımdırmı - növbəti kimi və necə əlaqə saxlamaq?',
			es: '¿Necesitan tus comerciales colas de acciones diarias guiadas por IA - a quién contactar después y cómo?',
		},
		options: [
			{
				text: {
					en: 'No - reps manage their own schedules',
					uk: 'Ні - менеджери самі керують своїм графіком',
					pl: 'Nie - handlowcy zarządzają własnym grafikiem',
					ge: 'არა - წარმომადგენლები თავად მართავენ თავიანთ განრიგს',
					az: 'Xeyr - nümayəndələr öz qrafiklərini idarə edir',
					es: 'No - los comerciales gestionan sus propias agendas',
				},
				smart: 3,
				d365: 0,
			},
			{
				text: {
					en: 'Would help, but not essential',
					uk: 'Було б корисно, але не критично',
					pl: 'Pomogłoby, ale nie jest konieczne',
					ge: 'დახმარება იქნება, მაგრამ არა არსებითი',
					az: 'Kömək edər, amma vacib deyil',
					es: 'Ayudaría, pero no es esencial',
				},
				smart: 2,
				d365: 1,
			},
			{
				text: {
					en: 'Yes - we want structured sequences with guided outreach',
					uk: 'Так - потрібні структуровані сценарії з підказками для outreach',
					pl: 'Tak - chcemy uporządkowanych sekwencji z guidance do outreach',
					ge: 'დიახ - გვინდა სტრუქტურირებული სეკვენსები guided outreach-ით',
					az: 'Bəli - guided outreach ilə strukturlaşdırılmış sequence-lər istəyirik',
					es: 'Sí - queremos secuencias estructuradas con outreach guiado',
				},
				smart: 1,
				d365: 2,
			},
			{
				text: {
					en: 'Yes - critical, AI must drive the daily sales workflow',
					uk: 'Так - критично, AI має керувати щоденним sales workflow',
					pl: 'Tak - krytyczne, AI musi prowadzić codzienny workflow sprzedaży',
					ge: 'დიახ - კრიტიკულია, AI-მ უნდა მართოს ყოველდღიური sales workflow',
					az: 'Bəli - kritikdir, AI gündəlik satış workflow-unu idarə etməlidir',
					es: 'Sí - crítico, la IA debe dirigir el flujo diario de ventas',
				},
				smart: 0,
				d365: 3,
			},
		],
	},
];
